import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, Input, Form, Select, Tag, Tooltip } from 'antd';
import { DrawerExplanation } from '../../components/editor/DrawerExplanation';
import { ogTypes } from '../../constants/ogtypes';
import {
  PlusOutlined,
} from '@ant-design/icons';

const FormItem = Form.Item;
const { TextArea } = Input;

export class SeoDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.seo,
      inputVisible: false,
    };
  }

  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    seo: PropTypes.object.isRequired,
    onAttributeChange: PropTypes.func.isRequired,
  };

  componentDidUpdate(prevProps) {
    this.validateAll(this.props.seo)
  }

  validateAll = (seoProps) => {
    const {
      title, description, sitename,
    } = seoProps;

    // this.validateTitle(title);
    // this.validateDescription(description);
    // this.validateSiteName(sitename);
  }

  validateTitle = (title) => {
    if (typeof title === 'undefined' || title.length === 0) {
      this.setState({
        titleValidateStatus: 'warning',
        titleHelp: 'cannot be blank',
      });
      return;
    }
    // title exists
    if (title.length < 20) {
      this.setState({
        titleValidateStatus: 'warning',
        titleHelp: 'preferably 20+ chars',
      });
    }
    else {
      this.setState({
        titleValidateStatus: 'success',
        titleHelp: null,
      });
    }
  }

  validateDescription = (description) => {
    if (typeof description === 'undefined' || description.length === 0) {
      this.setState({
        descValidateStatus: 'warning',
        descHelp: 'cannot be blank',
      });
      return;
    }

    if (description.length < 250) {
      this.setState({
        descValidateStatus: 'warning',
        descHelp: 'preferably 250+ chars',
      });
    }
    else if (description.length >= 250 && description.length <= 300) {
      this.setState({
        descValidateStatus: 'success',
        descHelp: null,
      });
    }
    else if (description.length > 300) {
      this.setState({
        descValidateStatus: 'warning',
        descHelp: (`try removing ${description.length - 300} chars`),
      });
    }
  }

  validateSiteName = (sitename) => {
    if (typeof sitename === 'undefined' || sitename.length === 0) {
      this.setState({
        sitenameValidateStatus: 'warning',
        sitenameHelp: 'cannot be blank',
      });
      return;
    }

    if (sitename.length < 6) {
      this.setState({
        sitenameValidateStatus: 'warning',
        sitenameHelp: 'too short',
      });
    }
    else {
      this.setState({
        sitenameValidateStatus: 'success',
        sitenameHelp: null,
      });
    }
  }

  onTitleChange = (e) => {
    const { value } = e.target;
    this.validateTitle(value);
  };

  onTitleBlur = (e) => {
    this.props.onAttributeChange('title', e.target.value);
  };

  onDescChange = (e) => {
    const { value } = e.target;
    this.validateDescription(value);
  }

  onDescBlur = (e) => {
    this.props.onAttributeChange('description', e.target.value);
  };

  onSitenameChange = (e) => {
    const { value } = e.target;
    this.validateSiteName(value);
  }

  onSitenameBlur = (e) => {
    this.props.onAttributeChange('sitename', e.target.value);
  }


  onTypeChange = (value) => {
    this.props.onAttributeChange('ogType', value);
  }

  deletePrimaryKey = () => {
    this.props.onAttributeChange('primaryKey', '');
  }

  onPrimaryKeyPressEnter = (e) => {
    const { value } = e.target;
    this.props.onAttributeChange('primaryKey', value);
  };

  handleClose = removedTag => {
    const secondaryKeysArray = this.currentSecondaryKeysArray();
    const updatedSecondaryKeysArray = secondaryKeysArray.filter(tag => tag !== removedTag);
    this.props.onAttributeChange('secondaryKeys', updatedSecondaryKeysArray.join(','));
    this.setState({ inputVisible: false });
  };

  currentSecondaryKeysArray = () => {
    const { secondaryKeys } = this.props.seo;
    const secondaryKeysArray = (typeof secondaryKeys === 'undefined') ? [] : (
      secondaryKeys.split(',', 100).filter(word => word.length > 0)
    );
    return secondaryKeysArray;
  }

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  saveInputRef = input => (this.input = input);

  handleInputConfirm = (e) => {
    const { value } = e.target;
    if (value.length === 0) {
      this.setState({ inputVisible: false });
      return;
    }
    const secondaryKeysArray = this.currentSecondaryKeysArray();

    if (secondaryKeysArray.indexOf(value) === -1) {
      this.props.onAttributeChange('secondaryKeys', [...secondaryKeysArray, value].join(','));
    }
    this.setState({ inputVisible: false });
  };

  render() {
    const {
      title, description, sitename,
      primaryKey, ogType,
    } = this.props.seo;
    const primaryKeyExists = typeof primaryKey !== 'undefined' && primaryKey.length > 0;

    const secondaryKeysArray = this.currentSecondaryKeysArray();

    const ogTypeItems = ogTypes.map((ogtype) => (
      <Select.Option key={ogtype} value={ogtype}>{ogtype}</Select.Option>
    ));

    return (
      <Drawer
        title="S.E.O. Headers"
        placement="right"
        className="editor__drawer"
        closable={true}
        onClose={this.props.onClose}
        visible={this.props.visible}
        destroyOnClose={true}
        width={300}
      >

        <DrawerExplanation
          title="Title"
          explanation="Always have a unique tag for every page. Appears on browser tabs, and crucial for SEO. Preferably under 60 chars."
        />
        <FormItem
          validateStatus={this.state.titleValidateStatus}
          hasFeedback={false}
          help={this.state.titleHelp}
        >
          <TextArea
            onChange={this.onTitleChange}
            onBlur={this.onTitleBlur}
            defaultValue={title}
            autoSize={{ maxRows: 2 }}
          />
        </FormItem>


        <DrawerExplanation
          title="Description"
          explanation="A brief summary or ad-copy of this page that shows up under search results. Keep this between 250 to 300 characters, typically truncated at 160."
        />
        <FormItem
          validateStatus={this.state.descValidateStatus}
          help={this.state.descHelp}
        >
          <TextArea
            onChange={this.onDescChange}
            onBlur={this.onDescBlur}
            autoSize={{ maxRows: 7 }}
            defaultValue={description}
          />
        </FormItem>


        <DrawerExplanation
          title="Site name"
          explanation="Name of the site that this page is a part of. Typically name of your business entity/ product."
        />
        <FormItem
          validateStatus={this.state.sitenameValidateStatus}
          hasFeedback={this.state.sitenameHasFeedback}
          help={this.state.sitenameHelp}
        >
          <TextArea
            onChange={this.onSitenameChange}
            onBlur={this.onSitenameBlur}
            defaultValue={sitename}
            autoSize={{ maxRows: 2 }}
          />
        </FormItem>


        <DrawerExplanation
          title="Primary keyword"
          explanation="The single most relevant keyword."
        />
        {
          (primaryKeyExists) ? (
            <Tag
              color="#1890FF"
              closable={true}
              onClose={this.deletePrimaryKey}
            >
              {primaryKey}
            </Tag>
          ) : (
            <Input
              onPressEnter={this.onPrimaryKeyPressEnter}
              onBlur={this.onPrimaryKeyPressEnter}
            />
          )
        }

        <DrawerExplanation
          title="Additional keywords"
          explanation="Other keywords in decreasing order of priority"
        />

        <FormItem
          hasFeedback
        >
          {
            secondaryKeysArray.map((tag) => {
              const isLongTag = tag.length > 20;
              const tagElem = (
                <Tag
                  key={tag}
                  closable={true}
                  onClose={() => this.handleClose(tag)}
                >
                  {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                </Tag>
              );
              return isLongTag ? (
                <Tooltip title={tag} key={tag}>
                  {tagElem}
                </Tooltip>
              ) : (
                tagElem
              );
            })
          }
          {this.state.inputVisible && (
            <Input
              ref={this.saveInputRef}
              type="text"
              size="small"
              style={{ width: 78 }}
              onBlur={this.handleInputConfirm}
              onPressEnter={this.handleInputConfirm}
            />
          )}
          {!this.state.inputVisible && (
            <Tag
              onClick={this.showInput}
              style={{ background: '#fff', borderStyle: 'dashed' }}
            >
              <PlusOutlined /> New Tag
            </Tag>
          )}
        </FormItem>

        <DrawerExplanation
          title="Open graph type"
          explanation="Choose the type of entity represented by this page. Decides how Facebook presents this page when shared over social media."
        />

        <FormItem
          hasFeedback
        >
          <Select
            placeholder="Select type"
            style={{ width: '100%' }}
            defaultValue={ogType}
            onChange={this.onTypeChange}
          >
            { ogTypeItems }
          </Select>

        </FormItem>

      </Drawer>

    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/SeoDrawer.jsx